class ClinicalStudiesTagFilter extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', e => {
      const link = e.target.closest('[data-tag-link]');
      if (!link) return;
      e.preventDefault();
      this._filter(link.pathname);
    });

    this.querySelector('[data-tag-select]')?.addEventListener('change', e => {
      const a = document.createElement('a');
      a.href = e.target.value;
      this._filter(a.pathname);
    });
  }

  _updateActive(path) {
    this.querySelectorAll('[data-tag-link]').forEach(link => {
      link.classList.toggle('is-active', link.pathname === path);
    });

    const select = this.querySelector('[data-tag-select]');
    if (select) {
      [...select.options].forEach(o => {
        const a = document.createElement('a');
        a.href = o.value;
        o.selected = a.pathname === path;
      });
    }
  }

  _filter(path) {
    this._updateActive(path);
    history.pushState({}, '', path);
    document.dispatchEvent(new CustomEvent('clinical-studies:filter', { detail: { url: location.origin + path } }));
  }
}

if (!customElements.get('clinical-studies-tag-filter')) {
  customElements.define('clinical-studies-tag-filter', ClinicalStudiesTagFilter);
}
